module.exports = __webpack_public_path__ + "static/media/youtube.e39f4063.webp";